import _ from "lodash";
import moment from "moment";
import * as api from "~/api/resource";
export default class RouterEngine {
  constructor(vue, legs = null, locs = null, contacts = null) {
    this.vm = vue;
    this.routeAssets = null;
    this.vehicleAssets = null;
    this.liveData = {};
    this.externalVehicleIds = {};
    this.legs = {};
    this.locs = {};
    this.usedLocs = {};
    this.AIRPORT = 51;
    this.filters = { routetypes: [] };
    this.contacts = {};
    this.console_log_hidden = function() {};
    contacts.forEach((c) => {
      this.contacts["" + c.id] = c;
    });

    var legs_repo = this.legs,
      locs_repo = this.locs;
    const RH = this;
    legs.forEach((l) => {
      legs_repo[l.a + "." + l.z] = l.d;
    });
    var idx = 2;
    locs.forEach((p) => {
      if (p.id == RH.AIRPORT) p.idx = 0;
      else p.idx = ++idx;
      locs_repo[p.id] = p;
    });

    this.vehicleWeighters = {
      nowis(nowis, routeObject, vehicleObject) {
        if (!routeObject) return { hard: 0, soft: 0 };
        var ss = 0,
          ps = 0;
        // this.console_log_hidden('loc.CHECK.' + vehicleObject.name, vehicleObject, routeObject)
        if (!nowis.locid && vehicleObject.ended)
          ps = vehicleObject.ended.lastLoc != RH.AIRPORT ? 10 : 0;
        else
          (ss = nowis.speed ? parseFloat(nowis.speed) : 0),
            (ps = nowis.locid != RH.AIRPORT ? 2 : 0);

        if (RH.isOnRoute(vehicleObject)) return { hard: 0, soft: 200 };
        else {
          ss =
            5 *
            RH.getTravelTime(routeObject.startLocId, vehicleObject.nowis.locid);
          // this.console_log_hidden(
          //   "loc..SCORE d " + vehicleObject.name,
          //   ss,
          //   routeObject.startLocId,
          //   vehicleObject.nowis.locid
          // );
        }
        if (ss > 30) ps = 80;
        if (!ss) ss = 100;
        // this.console_log_hidden("loc..SCORE " + vehicleObject.name, ss, ps);
        if (nowis && nowis.status == "MOVING") ss += 5;

        return { hard: 0, soft: ss + ps };
      },

      capacity(capacity, routeObject) {
        if (!capacity) return { hard: 0, soft: 9999 };
        capacity = capacity ? capacity : 0;

        if (!routeObject || !routeObject.id)
          return { hard: 0, soft: 100 - capacity };
        if (capacity < routeObject.pax)
          return {
            hard: routeObject.pax - capacity,
            soft: routeObject.pax - capacity,
          };
        else {
          // this.console_log_hidden('accept r..' + capacity, routeObject.pax, (10 * (capacity - routeObject.pax) ^ 2))
          return {
            hard: 0,
            soft:
              capacity - routeObject.pax > 20
                ? 100
                : (capacity - routeObject.pax) / 20,
          };
        }
      },
      penaldy(ended, routeObject, vehicleObject) {
        var vendInfo = vehicleObject.ended,
          timePenaldy = 0;
        // this.console_log_hidden('ended r..' + routeObject.startLocId, routeObject)
        if (routeObject && routeObject.id) {
          const startTimeMM = routeObject.startTimeMM;

          if (!vendInfo) return { hard: 0, soft: 0 };
          const FT = vendInfo.freeTime ? vendInfo.freeTime : 0,
            timeBeThere =
              FT + RH.getTravelTime(routeObject.startLocId, vendInfo.lastLoc);

          if (startTimeMM > timeBeThere) {
            var bonus = 10;
            if (
              vehicleObject.nowis.status == "STOPED" &&
              vehicleObject.nowis.locid + "" == routeObject.startLocId + ""
            )
              bonus = 0;

            bonus += routeObject.startLocId == vendInfo.lastLoc ? 0 : 30;
            if (RH.nowInMinutes() < FT) bonus += 10;

            if (RH.nowInMinutes() < timeBeThere) bonus += 10;
            // this.console_log_hidden('anal...', (100 * timePenaldy + bonus * 100 + (startTimeMM - timeBeThere)), timePenaldy, bonus, startTimeMM, timeBeThere)
            // if (this.nowInMinutes() > timeBeThere)
            return { hard: 0, soft: bonus / 10, howBad: bonus };
            // else
            //     return { hard: 0, soft: 600 + bonus + (timeBeThere - routeObject.startTimeMM) }
          }
        }
      },
      endedTime(ended, routeObject, vehicleObject) {
        var vendInfo = vehicleObject.ended,
          timePenaldy = 0;
        // this.console_log_hidden('ended r..' + routeObject.startLocId, routeObject)
        if (routeObject && routeObject.id) {
          const startTimeMM = routeObject.startTimeMM;

          if (!vendInfo) return { hard: 0, soft: 0 };
          const FT = vendInfo.freeTime ? vendInfo.freeTime : 0,
            timeBeThere =
              FT + RH.getTravelTime(routeObject.startLocId, vendInfo.lastLoc);

          if (startTimeMM < timeBeThere)
            return {
              hard: timeBeThere - routeObject.startTimeMM,
              soft: timeBeThere - routeObject.startTimeMM,
            };
          else {
            if (RH.nowInMinutes() > FT)
              timePenaldy =
                1 - Math.floor((RH.nowInMinutes() - FT) / RH.nowInMinutes());
            if (RH.nowInMinutes() < timeBeThere) timePenaldy += 10;
            // this.console_log_hidden('anal...', (100 * timePenaldy + bonus * 100 + (startTimeMM - timeBeThere)), timePenaldy, bonus, startTimeMM, timeBeThere)
            // if (this.nowInMinutes() > timeBeThere)
            return { hard: 0, soft: 100 * timePenaldy };
            // else
            //     return { hard: 0, soft: 600 + bonus + (timeBeThere - routeObject.startTimeMM) }
          }
        } else {
          if (vehicleObject.status == "OFFLINE") return { hard: 0, soft: 200 };
          if (vehicleObject.status == "STOPED")
            return {
              hard: 0,
              soft: (24 * 60 * 60 - this.nowInUnx() - vehicleObject.time) / 100,
            };
        }
      },
      assignedRoutes(ended, routeObject, vehicleObject) {
        var ended = vehicleObject.ended;
        // this.console_log_hidden('ended r..' + routeObject.startLocId, routeObject)

        // var sa = (ended.routesAssigned) ? (10 + 2 * ended.routesAssigned) : 0, sb = (ended.routesToGo) ? (10 + 2 * ended.routesToGo) : 0
        return {
          hard: 0,
          soft: 10 * (ended.routesAssigned ? ended.routesAssigned : 0),
        };
      },
      endedLocation(ended, routeObject, vehicleObject) {
        var vendInfo = vehicleObject.ended,
          penaldy = 0;

        // this.console_log_hidden('ended r..' + routeObject.startLocId, routeObject)
        if (routeObject && routeObject.id) {
          if (!vehicleObject.nowis.locid + "" != routeObject.startLocId)
            penaldy = 10;
          if (routeObject.startLocId != vendInfo.lastLoc) penaldy += 100;
          const tm = RH.getTravelTime(routeObject.startLocId, vendInfo.lastLoc);
          penaldy += tm;
          // this.console_log_hidden('is at ' + vehicleObject.name, tm, routeObject.startLocId, vendInfo.lastLoc)
          return { hard: 0, soft: penaldy };
        }
      },

      sapplierId(sapplierId) {
        return { hard: sapplierId ? 10 : 0, soft: 0 };
      },
      // active(active) {
      //     return { hard: ((active) ? 0 : 100), soft: 0 }
      // }
    };
    this.routeWeighters = {
      pax(pax, vehicleObject) {
        if (!vehicleObject || !vehicleObject.id) return { hard: 0, soft: 0 };
        if (pax > vehicleObject.capacity)
          return {
            hard: pax - vehicleObject.capacity,
            soft: pax - vehicleObject.capacity,
          };
        else
          return { hard: 0, soft: (100 * (vehicleObject.capacity - pax)) ^ 2 };
      },
      asset_id(asset_id, vehicleObject) {
        // this.console_log_hidden('ela..VVV..', asset_id)
        // if (asset_id != vehicleObject.id) return { hard: 0, soft: 0 }
        if (!asset_id) return { hard: 0, soft: 0 };
        else return { hard: 100000, soft: 10000 };
      },
      locseq(locseq) {
        const ps = locseq.split(","),
          p = RH.locs[ps[0]];
        // if (p) this.console_log_hidden('foun dfpos..', p.idx / 1000)
        if (p) return { hard: 0, soft: p.idx / 1000 };
        return { hard: 0, soft: 0 };
      },
      startTimeMM(startTimeMM, vehicleObject, routeObject) {
        const clock = new Date();
        var timeMM = clock.getHours() * 60 + clock.getMinutes();
        var vendInfo = vehicleObject.ended;
        if (!vehicleObject || !vehicleObject.id) {
          // timeMM += RH.getTravelTime(routeObject.startLocId, RH.AIRPORT)

          // return { hard: 0, soft: 24 * 3600 - (startTimeMM - timeMM) }
          // this.console_log_hidden('ela..NO..', timeMM, startTimeMM)

          return { hard: 0, soft: startTimeMM - timeMM };
          // if (startTimeMM < timeMM) {

          //     if (routeObject.asset_id) {
          //         return { hard: (timeMM - startTimeMM) * 100, soft: (startTimeMM - timeMM) }
          //     } else
          //         return { hard: 0, soft: (timeMM - startTimeMM) }
          // } else {
          //     if (routeObject.asset_id) {
          //         return { hard: (startTimeMM - timeMM) * 100, soft: 24 * 3600 - (startTimeMM - timeMM) }
          //     } else
          //         return { hard: 0, soft: 24 * 3600 - (startTimeMM - timeMM) }
          // }
        } else {
          // this.console_log_hidden('ela....', vehicleObject)
          if (!vendInfo) return { hard: 0, soft: 0 };
          const timeBeThere =
            vendInfo.freeTime +
            RH.getTravelTime(routeObject.startLocId, vendInfo.lastLoc);
          // this.console_log_hidden('ela....' +timeBeThere+'??'+ RH.translateRoute([routeObject.startLocId]) + '>' + RH.translateRoute([vendInfo.lastLoc]), vendInfo.freeTime, RH.getTravelTime(routeObject.startLocId, vendInfo.lastLoc))
          // this.console_log_hidden('ela=' + Math.floor(timeBeThere / 60) + ':' + (timeBeThere % 60))
          if (startTimeMM < timeBeThere)
            return {
              hard: timeBeThere - routeObject.startTimeMM,
              soft: timeBeThere - routeObject.startTimeMM,
              timeBeThere: timeBeThere,
            };
          else
            return {
              hard: 0,
              soft: 24 * 60 - (timeBeThere - routeObject.startTimeMM),
              timeBeThere: timeBeThere,
            };
        }
      },
    };
  }
  isOnRoute(vehicle, chktime) {
    var vroutes = this.getRoutes(vehicle),
      chktime = chktime ? chktime : this.nowInMinutes(),
      isonroute = false;
    if (vroutes)
      vroutes.forEach((r) => {
        endData.startTimeMM = lastRoute.startTimeMM;
        endData.endTimeMM = lastRoute.endTimeMM;
        if (
          lastRoute.startTimeMM <= chktime &&
          chktime <= lastRoute.endTimeMM
        ) {
          isonroute = true;
          return;
        }
      });
    return isonroute;
  }
  // translateExecLog(routeData) {
  //     if (routeData && routeData.execLog && !routeData.visLog)
  //         try {
  //             var visLog = {}
  //             // routeData.visLog={}
  //             const routelog = JSON.parse(routeData.execLog);
  //             for (const key in routelog) {
  //                 if (routelog.hasOwnProperty(key)) {
  //                     visLog[key] = routelog[key];
  //                     // visLog.locCode=this.g
  //                 }
  //             }
  //             routeData.execLogTrack = JSON.parse(routeData.execLog);
  //         } catch (error) { }
  // }
  estimateNoGPSdata(vehicle) {
    const rtr = this;
    var rts = rtr.getRoutes(vehicle.id);
    var lastRoute = null,
      lastTime = null;
    // this.console_log_hidden('Check vehicle ' + vehicle.name, rts)
    if (rts)
      rts.forEach((r) => {
        if (!lastTime || lastTime < r.startTimeMM) {
          lastTime = r.startTimeMM;
          lastRoute = r;
        }
      });
    // this.console_log_hidden('as last root ', lastRoute)
    if (lastRoute && lastRoute.locseq) {
      // this.console_log_hidden('as last root  found ' + vehicle.name, lastRoute)
      var rps = lastRoute.locseq.split(",");
      const endData = vehicle.ended ? vehicle.ended : {}; //if(!vehicle.ended)
      endData.lastLoc = parseInt(rps[rps.length - 1]);
      endData.startTimeMM = lastRoute.startTimeMM;
      endData.endTimeMM = lastRoute.endTimeMM;
      endData.freeTime = lastRoute.endTimeMM;
      endData.routesAssigned = rtr.getRoutes(vehicle.id).length;
      rtr.vm.$set(vehicle, "ended", endData);

      // return { lastLoc: parseInt(rps[rps.length - 1]), startTimeMM: lastRoute.startTimeMM, endTimeMM: lastRoute.endTimeMM, routesAssigned: rtr.getRoutes(vehicle.id).length }
    }
    // this.console_log_hidden('as root ', r)
    return vehicle;
  }
  getContact(cid) {
    return this.contacts[cid];
  }
  setLiveData(data) {
    if (!this.vehicleAssets) return;
    const rtr = this;
    var p = null;
    data.results.forEach((p) => {
      rtr.liveData[p.id + ""] = p;
    });

    var ulocs = {};
    this.vehicleAssets.forEach((v) => {
      p = rtr.liveData[v.id + ""];

      // var v = rtr.getVehicle(p.id)
      if (p) {
        if (p.locid && !ulocs[p.locid])
          ulocs[p.locid] = { name: p.resort, id: p.locid };
        if (p.routes) {
          p.routes.forEach((r) => {
            try {
              if (_.isString(r.execLog)) r.execLog = JSON.parse(r.execLog);

              // rtr.updateRoute({ execLog: jr ,endTimeMM:r.endTimeMM}, r.id)
            } catch (error) {
              console.error("problem parsin exec log for.." + r.execLog, r);
            }
            if (r.ntf_update) {
              _log_("WORK BUS" + v.name, r);
              // r.ntf_update.driverName = this.getContact(r.driver_contact_id);
              if (r.ntf_update.timeSent)
                r.ntf_update.timeSentHuman = this.vm.formatUnxTime(
                  r.ntf_update.timeSent
                );
              if (r.ntf_update.timeInteracted)
                r.ntf_update.timeInteractedHuman = this.vm.formatUnxTime(
                  r.ntf_update.timeInteracted
                );
            }
            const dr = this.getContact(r.driver_contact_id);
            rtr.updateRoute(
              {
                driverName: dr ? dr.name : null,
                execLog: r.execLog,
                endTimeMM: r.endTimeMM,
                ntf_update: r.ntf_update,
              },
              r.id
            );
            this.console_log_hidden(
              "UPDATE R..." +
                v.name +
                "(" +
                r.id +
                "@" +
                rtr.vm.intToTime(r.endTimeMM) +
                "<<" +
                r.endTimeMM,
              r
            );
          });

          // if(p.routes)
        }
      }
      if (p) {
        rtr.vm.$set(v, "nowis", p);
        // this.console_log_hidden('live...', p)
        // var endData = v.ended
        // endData.routesAssigned = rtr.getRoutes(v.id).length
        //    rtr.vm.$set(v, 'ended', endData)
      }
      v = rtr.estimateNoGPSdata(v);
      // this.console_log_hidden('set v...', v)
      //extra data
      //  if (RH.liveData[v.id + ""]) RH.vm.$set(v, 'nowis', RH.liveData[v.id + ""])
      //  else RH.vm.$set(v, 'nowis', {})
    });
  }

  translateRoute(locs) {
    // this.console_log_hidden('checking r..', locs)
    var route_names = [],
      RH = this;
    locs.forEach((l) => {
      const loc = RH.locs[l] ? RH.locs[l].code : "?";
      if (route_names.indexOf(loc) < 0) route_names.push(loc);
    });
    return route_names.join("-");
  }

  setVehicleWeighter(
    prop,
    weightFunc = function(propVal, routeObject, vehicleObject) {
      return { hard: 0, soft: 0 };
    }
  ) {
    if (prop && weightFunc) this.vehicleWeighters[prop] = weightFunc;
  }
  setRouteWeighter(
    prop,
    weightFunc = function(propVal, vehicleObject, routeObject) {
      return { hard: 0, soft: 0 };
    }
  ) {
    if (prop && weightFunc) this.routeWeighters[prop] = weightFunc;
  }
  composeMessage(routeData) {
    //make messages
    const escort = routeData.escort_contact_id
      ? this.getContact(routeData.escort_contact_id)
      : null;
    this.console_log_hidden("messsgggg", routeData);
    if (routeData.driver_contact_id) {
      var msg = "",
        aadEscort = true;
      //DEPARTURE
      if (
        routeData.pupnameA != "Airport" &&
        (routeData.destination == "TRANSIT" ||
          routeData.destination == "TRANSFER")
      ) {
        msg =
          msg +
          routeData.startTimeHuman +
          " " +
          routeData.pupnameA +
          " " +
          routeData.distributors;
      }
      if (
        routeData.pupnameA == "Airport" &&
        (routeData.destination == "TRANSIT" ||
          routeData.destination == "TRANSFER")
      ) {
        let tmm = routeData.startTimeMM - 30;
        msg =
          Math.floor(tmm / 60) +
          ":" +
          (tmm % 60 < 10 ? "0" + (tmm % 60) : tmm % 60) +
          " " +
          routeData.pupnameA;
        aadEscort = false;
      }
      if (routeData.destination == "PICKUP") {
        let tmm = routeData.startTimeMM;
        msg =
          Math.floor(tmm / 60) +
          ":" +
          (tmm % 60 < 10 ? "0" + (tmm % 60) : tmm % 60) +
          " " +
          routeData.pupnameA;
      }
      if (routeData.destination == "EXCRS") {
        let tmm = routeData.startTimeMM;
        msg =
          Math.floor(tmm / 60) +
          ":" +
          (tmm % 60 < 10 ? "0" + (tmm % 60) : tmm % 60) +
          " " +
          routeData.pupnameA;

        if (routeData.locseq.length) {
          const locs = this.locations,
            last_id = routeData.locseq[routeData.locseq.length - 1],
            exrs = _.find(locs, { id: last_id });
          if (exrs) msg += " EXCRS:" + exrs.name;
        }
      }

      if (aadEscort)
        if (routeData.escort_contact_id) {
          const esccnt = this.getContact(routeData.escort_contact_id);
          if (esccnt) {
            msg += " Escort:" + esccnt.name + " ";
          } else msg += " ΜΕ ΛΙΣΤΑ";
        } else msg += " ΜΕ ΛΙΣΤΑ";
      this.console_log_hidden("messsgggg OUT", msg);
      return msg;
    }
    return false;
  }
  async updateRoute(routeData, routeId, persist) {
    routeId = routeId ? routeId : routeData.id;
    if (!routeId) return null;
    var r = _.find(this.routeAssets, { id: routeId }),
      removed_contact_id = null;
    if (r)
      for (const key in routeData) {
        if (routeData.hasOwnProperty(key)) {
          // this.console_log_hidden("tr ddata,,", key, routeData[key]);
          // r[key] = element
          if (key == "asset_id")
            if (r.asset_id && routeData.asset_id + "" != r.asset_id + "") {
              //route is removed from contact
              removed_contact_id = r.driver_contact_id;
              this.console_log_hidden("removING dr...", removed_contact_id);
            }
          this.vm.$set(r, key, routeData[key]);
        }
      }
    _log_("UPDATE ROUTE,," + routeId, routeData, "->", r);
    if (persist) {
      if (removed_contact_id) {
        try {
          var msg = await api.updateProcessor(
            "notifications/pushnotifications",
            {
              msg: "FORGET about:" + this.composeMessage(r),
              contact_id: removed_contact_id,
              routeId: r.id,
              routename: r.routename,
              do: "remove",
            }
          );
          this.console_log_hidden("removed...", msg);
        } catch (error) {
          console.error("Notification failed:", error);
        }
      }
      // r.driver_contact_id
      const data = await api.updateProcessor("route/update", {
        id: r.id,
        asset_id: r.asset_id,
        updatetime: r.updatetime,
        date: r.date,
      });
      this.vm.$set(r, "driver_contact_id", data.driver_contact_id);
      this.vm.$set(r, "updatetime", data.updatetime);
      this.console_log_hidden(
        "[update route]...",
        this.composeMessage(r),
        data
      );
      if (data.driver_contact_id) {
        try {
          const notificationData = await api.updateProcessor(
            "notifications/pushnotifications",
            {
              msg: this.composeMessage(r),
              contact_id: data.driver_contact_id,
              routeId: r.id,
              routename: r.routename,
            }
          );
        } catch (error) {
          console.error("Notification failed:", error);
          return true;
        }
        // this.console_log_hidden("[update notifiacation]...", notificationData);
      }
    }
    return true;
  }
  updateVehicle(vehicleData, vehicleId) {
    vehicleId = vehicleId ? routeId : vehicle.id;
    if (!vehicleId) return null;
    var v = _.find(this.vehicleAssets, { id: vehicleId });
    if (v)
      for (const key in vehicleData) {
        if (vehicleData.hasOwnProperty(key)) {
          // const element = vehicleData[key];
          // v[key] = element
          this.vm.$set(v, key, vehicleData[key]);
        }
      }
  }
  setRoutes(routeAssets = null) {
    const RH = this;
    this.routeAssets = [];
    var now = new Date(),
      nowMinutes = now.getHours() * 60 + now.getMinutes();
    routeAssets.forEach((route) => {
      if (route.locseq) {
        const locsArr = route.locseq.split(",");
        //add exec info
        var maybe = false,
          endCondition = null;
        if (route.asset_id) {
          if (route.endTimeMM && route.endTimeMM + 30 < nowMinutes)
            maybe = true;
          if (route.execLog) {
            const last = route.execLog[route.execLog.length - 1];
            if (last && last.time && last.time != "0") endCondition = "sure";
          }
          if (!endCondition) endCondition = maybe ? "maybe" : "notyet";
        }
        // route.startLocId = locsArr[0]
        RH.vm.$set(route, "timePassed", route.startTimeMM < nowMinutes);
        RH.vm.$set(route, "isDone", endCondition);
        RH.vm.$set(route, "weight", {});
        RH.vm.$set(route, "startLocId", locsArr[0]);
        RH.vm.$set(route, "loc_seq_trans", RH.translateRoute(locsArr));
        if (locsArr[0] == RH.AIRPORT) RH.vm.$set(route, "direction", "ARV");
        if (locsArr[locsArr.length - 1] == RH.AIRPORT)
          RH.vm.$set(route, "direction", "DEP");
        // if (this.routeData.loc_seq_trans.indexOf("AIR") > 3) return "departure";
        if (!route.execLog && route.loc_seq_trans) {
          var el = [];
          route.loc_seq_trans.split("-").forEach((loc) => {
            el.push({ code: loc });
          });
          RH.vm.$set(route, "execLog", el);
        }

        // route.loc_seq_trans = RH.translateRoute(locsArr)
      } else RH.vm.$set(route, "loc_seq_trans", "");

      this.routeAssets.push(route);
    });
    //this.routeAssets = routeAssets
  }

  getRoutes(forVehicle, toGo) {
    const clock = new Date();
    var timeMM = clock.getHours() * 60 + clock.getMinutes();
    return this.routeAssets.filter(function(r) {
      if (toGo)
        return r.asset_id + "" == forVehicle + "" && r.startTimeMM >= timeMM;
      else return r.asset_id + "" == forVehicle + "";
    });
  }

  setVehicles(vehicleAssets = null, setAvailableLocs) {
    const today = new Date(),
      td = today.getDate(),
      RH = this;
    var ulocs = {};
    // this.console_log_hidden('checking r.usedLocs.go...', this.usedLocs);
    vehicleAssets.map((v) => {
      var vEndData = v.ended;
      this.console_log_hidden("csettingV...", v.name, v.sapplierId);
      if (v.sapplierId) RH.externalVehicleIds[v.id] = v;
      if (vEndData && vEndData.unxStartTime) {
        if (td != moment.unix(vEndData.unxStartTime).format("D")) {
          vEndData.endTimeMM = 0;
        }
      }
      if (!vEndData) vEndData = {};
      vEndData.routesAssigned = RH.getRoutes(v.id).length;
      vEndData.routesToGo = RH.getRoutes(v.id, true).length;
      // if (vEndData.routesToGo && !vEndData) //this.console_log_hidden('???no live ', vEndData.routesToGo)
      if (setAvailableLocs)
        if (vEndData.lastLoc && !ulocs[vEndData.lastLoc])
          ulocs[vEndData.lastLoc] = {
            name: RH.locs[vEndData.lastLoc]
              ? RH.locs[vEndData.lastLoc].code
              : "!!!" + vEndData.lastLoc,
            id: vEndData.lastLoc,
          };
      // this.console_log_hidden('???', vEndData)
      RH.vm.$set(v, "ended", vEndData);
      RH.vm.$set(v, "weight", {});
      var checkActice = RH.vm.doYouRember("vehicle_active_" + v.id);
      this.console_log_hidden("??MEMO?", "vehicle_active_" + v.id, checkActice);
      if (v.active == undefined) RH.vm.$set(v, "active", true);
      if (checkActice !== undefined) RH.vm.$set(v, "active", checkActice);
      return v;
    });
    // this.usedLocs=ulocs;
    if (setAvailableLocs) this.vm.$set(this, "usedLocs", ulocs);
    //this.console_log_hidden('checking !!r.usedLocs.', this.usedLocs, ulocs)
    this.vehicleAssets = vehicleAssets;
  }
  getVehicle(vid) {
    const v = _.find(this.vehicleAssets, { id: vid });
    return v;
  }
  // getRoute(vid) {
  //     const v = _.find(this.vehicleAssets, { id: vid });
  //     return v;

  // }

  bestRoutes(forVehicle, timePriority) {
    const RH = this,
      now = new Date(),
      nowMinutes = now.getHours() * 60 + now.getMinutes();
    if (!this.routeAssets) return null;
    // this.console_log_hidden("befor....", RH.routeAssets);
    var lastParsedTime = null,
      wrs = RH.routeAssets;
    // wrs = (!RH.filters) ? RH.routeAssets : RH.routeAssets.filter(function (r) {
    //     if (RH.filters.routetypes) {
    //         this.console_log_hidden('chl.R.', r.destination)

    //         if (r.destination == "PICKUP" && RH.filters.routetypes.indexOf("PICKUP") >= 0) return true;
    //         if (r.destination == "EXCRS" && RH.filters.routetypes.indexOf("EXCRS") >= 0) return true;
    //         if (r.locseq) {
    //             if (r.locseq.indexOf(RH.AIRPORT) === 0 && RH.filters.routetypes.indexOf("ARV") >= 0) return true;

    //             if (r.locseq.indexOf(RH.AIRPORT) > 3 && RH.filters.routetypes.indexOf("DEP") >= 0) return true;
    //         }
    //         this.console_log_hidden('reject', r.destination)
    //         return false
    //     }
    // })
    // this.console_log_hidden('chl.V.', wrs.length, wrs)
    var RW = this.routeWeighters,
      sorted = wrs.map(function(route) {
        var rtWeight = { hard: 0, soft: 0, timeBeThere: 0 };
        // if (route.locseq) {
        //     const locsArr = route.locseq.split(',')
        //     // route.startLocId = locsArr[0]
        //     RH.vm.$set(route, 'startLocId', locsArr[0])
        //     RH.vm.$set(route, 'loc_seq_trans', RH.translateRoute(locsArr))
        //     // route.loc_seq_trans = RH.translateRoute(locsArr)
        // }
        // else RH.vm.$set(route, 'loc_seq_trans', '')
        RH.vm.$set(route, "showTime", true);
        // if (forVehicle)
        for (const key in RW) {
          if (RW.hasOwnProperty(key)) {
            const wFunc = RW[key];
            if (wFunc) {
              const score = wFunc(route[key], forVehicle, route);
              if (score) {
                if (score.timeBeThere) rtWeight.timeBeThere = score.timeBeThere;
                rtWeight.hard += score.hard;
                if (score.soft < 0) {
                  rtWeight.soft = score.soft; //this means that is overdued
                } else rtWeight.soft += score.soft ? score.soft : 0;
              }
            }
          }
        }

        if (route.asset_id) {
          const v = RH.getVehicle(route.asset_id);

          if (v) RH.vm.$set(route, "transmean", v.name);
        }
        //add exec info
        var maybe = false,
          endCondition = null;
        if (route.asset_id) {
          if (route.endTimeMM && route.endTimeMM + 30 < nowMinutes)
            maybe = true;
          if (route.execLog) {
            const last = route.execLog[route.execLog.length - 1];
            if (last && last.time && last.time != "0") endCondition = "sure";
          }
          if (!endCondition) endCondition = maybe ? "maybe" : "notyet";
        }
        // var bestLevel = 0;
        // if (forVehicle) {

        //     if (forVehicle.nowis.status == 'STOPED' && forVehicle.nowis.locid + "" == route.startLocId + "")
        //         bestLevel = bestLevel + 10
        //     if (forVehicle.freeTime < this.nowInMinutes())

        // }
        // RH.vm.$set(route, 'best', '')
        RH.vm.$set(route, "timePassed", route.startTimeMM < nowMinutes);
        RH.vm.$set(route, "isDone", endCondition);
        RH.vm.$set(route, "weight", rtWeight);
        return route;
      });
    sorted.sort(function(a, b) {
      if (timePriority) return a.startTimeMM - b.startTimeMM;
      var as = a.weight.hard * 100 + a.weight.soft,
        bs = b.weight.hard * 100 + b.weight.soft;
      return as - bs;
    });
    sorted.forEach((route) => {
      if (lastParsedTime == route.startTimeMM) route.showTime = false;
      //RH.vm.$set(route, 'showTime', false)
      else {
        lastParsedTime = route.startTimeMM;
        route.showTime = true;
        // RH.vm.$set(route, 'showTime', true)
      }
    });
    this.console_log_hidden("after...", RH.routeAssets);
    RH.routeAssets = sorted;
    return sorted;
  }
  findInArray(repoArray, searchObject) {
    var o = null;
    var countProps = 0;
    var countCorrects = 0;
    repoArray.forEach((element) => {
      countProps = 0;
      countCorrects = 0;
      for (const key in searchObject) {
        if (searchObject.hasOwnProperty(key)) {
          ++countProps;
          const sval = searchObject[key];
          if (element[key] + "" == sval + "") ++countCorrects;
        }
      }
      if (countCorrects == countProps) {
        o = element;
        return true;
      }
    });
    return o;
  }
  bestVehicles(forRoute) {
    const RH = this;
    if (!this.vehicleAssets) return null;
    var RW = this.vehicleWeighters,
      sorted = this.vehicleAssets.map(function(v) {
        var weight = { hard: 0, soft: 0 },
          endData = v.ended,
          log = {};
        if (endData)
          endData.lastLocCode = endData.lastLoc
            ? RH.translateRoute([endData.lastLoc])
            : "";
        else endData = {};
        //    this.console_log_hidden('chl.V.',v,RH.liveData[v.id + ""])
        if (v.active)
          for (const key in RW) {
            if (RW.hasOwnProperty(key)) {
              const wFunc = RW[key];
              if (wFunc) {
                const score = wFunc(v[key], forRoute, v);
                if (score) {
                  log[key] = score.soft;
                  if (score.howBad) weight.howBad = score.howBad;
                  weight.hard += score.hard;
                  if (score.soft < 0) {
                    this.console_log_hidden("DOWN ?????");
                    weight.soft = score.soft;
                  } //this means that is overdued
                  else weight.soft += score.soft ? score.soft : 0;

                  // this.console_log_hidden('ADDING ?????' + weight.soft, score)
                }
              }
            }
          }
        else weight = { hard: 1111110000, soft: 111111000 };
        weight.log = log;
        RH.vm.$set(v, "weight", weight);

        return v;
      });
    sorted.sort(function(a, b) {
      var as = a.weight.hard * 10000 + a.weight.soft,
        bs = b.weight.hard * 10000 + b.weight.soft;
      return as - bs;
    });
    return sorted;
  }
  getTravelTime(pupA, pupZ) {
    const RH = this;
    if (!pupA || !pupZ) return 600;
    if (pupA + "" == pupZ + "") return 0;
    const x = this.legs[pupA + "." + pupZ]
      ? this.legs[pupA + "." + pupZ]
      : this.legs[pupZ + "." + pupA];
    if (!x) {
      var leg = null,
        la = this.locs[pupA],
        lo = this.locs[pupZ];
      if (la && lo && la.lat && la.lon && lo.lat && lo.lon) {
        api
          .fetchProcessor("legs/getinfo", { pa: pupA, pz: pupZ })
          .then(function(res) {
            this.console_log_hidden("then.,..", res);
            if (res && res.data && res.data.results)
              RH.legs[pupA + "." + pupZ] = res.data.results[0];
            RH.vm.$notify({
              title: "Travel time update",
              message: la.code + "-" + lo.code,
              type: "warning",
            });
          });
        // if (time.results) x = time.results[0]
      }
    }
    return x ? x : 600;
  }

  getRouteTime(stops) {
    var lastStop = null,
      tm = 0,
      rtr = this;
    stops.forEach((st) => {
      if (!lastStop) lastStop = st;
      else tm += rtr.getTravelTime(lastStop, st);
    });
    return tm;
  }
  updateVehicleData() {
    var endedData = {},
      rtr = this;
    this.routeAssets.forEach((r) => {
      // this.console_log_hidden('go fot..', r.asset_id)
      var ee = endedData[r.asset_id]
        ? endedData[r.asset_id]
        : { freeTime: 0, startTimeMM: 0, lastLoc: null };
      if (r.startTimeMM > ee.freeTime) {
        const rstps = r.locseq.split(",");
        ee.freeTime = r.startTimeMM + rtr.getRouteTime(rstps);

        ee.startTimeMM = r.startTimeMM;
        ee.lastLoc = rstps[rstps.length - 1];
      }

      endedData[r.asset_id] = ee;
    });
    this.vehicleAssets.forEach((v) => {
      var ee = endedData[v.id];
      if (!ee) ee = {};
      if (!ee.freeTime) ee.freeTime = 0;
      if (!ee.lastLoc) ee.lastLoc = 0;
      this.vm.$set(v, "ended", ee);
    });
  }

  getLegs() {
    return this.legs;
  }
  nowInUnx() {
    const clock = new Date();
    return clock.getTime() / 1000;
  }
  nowInMinutes() {
    const clock = new Date();
    return clock.getHours() * 60 + clock.getMinutes();
  }
}
